module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "translateKpiDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM3001))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.lang.KM3008) + ": " + _vm._s(_vm.client.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectLocale"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3002))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectLocale",
      "placeholder": _vm.lang.KM3003
    },
    on: {
      "change": _vm.selectedLocaleChanged
    }
  }, _vm._l((_vm.avaibleLocaleList), function(locale) {
    return _c('option', {
      key: locale.LocaleCode,
      domProps: {
        "value": locale.LocaleCode
      }
    }, [_vm._v("\n                      " + _vm._s(locale.LocaleName) + "\n                    ")])
  }), 0)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "selectKpiTranslationProject"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3015))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('Select2', {
    staticClass: "form-control",
    attrs: {
      "id": "selectKpiTranslationProject",
      "placeholder": _vm.lang.KM3016,
      "allowClear": true
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                      " + _vm._s(project.ProjectName) + "\n                    ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputSearchKpi"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM3004))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKpiString),
      expression: "searchKpiString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inputSearchKpi"
    },
    domProps: {
      "value": (_vm.searchKpiString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKpiString = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedLocaleCode
    },
    on: {
      "click": function($event) {
        return _vm.getInitialSort()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lang.KM3014) + "\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "14%"
    },
    attrs: {
      "id": "kpiTypeColumnHeader"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Type')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3005) + "\n                      "), (_vm.showSortArrow('Type', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Type', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Text')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3006) + "\n                      "), (_vm.showSortArrow('Text', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Text', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Translation')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM3007) + "\n                      "), (_vm.showSortArrow('Translation', true)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Translation', false)) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInitialSort),
      expression: "isInitialSort"
    }],
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar"
  }, _vm._l((_vm.filteredKpiTranslations), function(kpiInformation, index) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          !_vm.selectedProject ||
          kpiInformation.ProjectGuid === _vm.selectedProject
        ),
        expression: "\n                    !selectedProject ||\n                    kpiInformation.ProjectGuid === selectedProject\n                  "
      }],
      key: index,
      class: {
        'kpi-group-table-row': !kpiInformation.KPIGroupGuid,
      }
    }, [_c('td', {
      staticStyle: {
        "width": "14%"
      }
    }, [_vm._v(_vm._s(kpiInformation.Type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "43%"
      }
    }, [_vm._v(_vm._s(kpiInformation.Text))]), _vm._v(" "), _c('td', {
      staticClass: "nopadding",
      staticStyle: {
        "width": "43%"
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiInformation.Translation),
        expression: "kpiInformation.Translation"
      }],
      staticClass: "form-control text-center textarea-kpi-translations autoExpand",
      attrs: {
        "rows": "1",
        "maxlength": "1000",
        "type": "text",
        "placeholder": kpiInformation.InheritedTranslation
      },
      domProps: {
        "value": (kpiInformation.Translation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(kpiInformation, "Translation", $event.target.value)
        }, function($event) {
          _vm.isTranslationDirty = true
        }]
      }
    })])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeKpiTranslationModal()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised",
    class: {
      'btn-warning': _vm.isTranslationDirty,
      'dialog-btn-primary': !_vm.isTranslationDirty,
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.globals.isAccessAllowed('LoopOp_KPIsTranslation_Update') ||
        !_vm.isTranslationDirty
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiTranslations()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.KM3000) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9563d628","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPIManagementTranslateModal.vue
// module id = 1710
// module chunks = 1